import React from "react";
import PageHeader from "../PageHeader/PageHeader";
import Section from "../Section/Section";
import { defineMessages, FormattedMessage } from "react-intl";
import longMessage from "../../../../../../../macros/longMessage.macro";
import track from "react-tracking";
const messages = defineMessages({
    header: {
        id: "legal.header",
        defaultMessage: "Legal Notice"
    },
    websiteTermsOfUse: {
        id: "legal.websiteTermsOfUse.header",
        defaultMessage: "Website Terms of Use"
    },
    disclaimer: {
        id: "legal.disclaimer.header",
        defaultMessage: "Disclaimer"
    },
    limitationOfLiability: {
        id: "legal.limitationOfLiability.header",
        defaultMessage: "Limitation of Liability"
    },
    applicableLaws: {
        id: "legal.applicableLaws.header",
        defaultMessage: "Applicable Laws"
    }
});
const LegalNotice = () => (<div className="wrapper">
		<PageHeader header={messages.header} effectiveDate={new Date(2020, 4, 23)}/>

		<Section title={messages.websiteTermsOfUse}>
			<FormattedMessage id="legal.websiteTermsOfUse" defaultMessage={longMessage `
					Your use of the DCM Services, LLC website represents your agreement to comply with all terms, including
					notices, of this site. DCM Services may change these terms at any time, and your use is subject to the
					changes. If you do not accept these terms, do not use this website. Use or reproduction of the content or
					materials for any purpose not expressly permitted is prohibited. DCM Services reserves the right, in its
					sole discretion, to terminate your access to all or part of this site, with or without notice.
				`}/>
		</Section>

		<Section title={messages.disclaimer}>
			<FormattedMessage id="legal.disclaimer" defaultMessage={longMessage `
					All materials, information and services included in or available through this site are provided "as is" and
					"as available" for your use. DCM Services disclaims all warranties of any kind, either express or implied,
					including, but not limited to, implied warranties of merchantability, fitness for a particular purpose or
					noninfringement. DCM Services does not warrant that the content of this website is accurate, reliable or
					correct; that this website will be available at any particular time or location; that any defects or errors
					will be corrected; or that the content is free of viruses or other harmful components. Your use of this
					website is solely at your risk. Because some jurisdictions do not permit the exclusion of certain
					warranties, these exclusions may not apply to you.
				`}/>
		</Section>

		<Section title={messages.limitationOfLiability}>
			<FormattedMessage id="legal.limitationOfLiability" defaultMessage={longMessage `
					DCM Services and its suppliers shall not be liable for any direct, indirect, punitive, incidental, special
					or consequential damages that result from the use of, or inability to use, this site. This limitation
					applies whether the alleged liability is based on contract, tort, negligence, strict liability or any other
					basis, even if DCM Services has been advised of the possibility of such damage. In jurisdictions that do not
					allow the exclusion or limitation of incidental or consequential damages, liability shall be limited to the
					extent permitted by law.
				`}/>
		</Section>

		<Section title={messages.applicableLaws}>
			<FormattedMessage id="legal.applicableLaws" defaultMessage={longMessage `
					All content and materials of this website are protected by copyrights, trademarks or other proprietary
					rights and laws. These terms and conditions shall be governed and construed in accordance with the laws of
					the state of Minnesota, USA, and applicable federal laws without regard to conflicts of law principles. You
					agree that any and all proceedings relating to this site and the subject matter contained herein shall be
					maintained in the courts of the state of Minnesota or the federal district courts sitting in Minnesota,
					which courts shall have exclusive jurisdiction for such purpose.
				`}/>
		</Section>
	</div>);
export default track({ page: "LegalNotice" }, { dispatchOnMount: true })(LegalNotice);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/legal/LegalNotice/LegalNotice.tsx